import { render, staticRenderFns } from "./kamikind.vue?vue&type=template&id=7da9c366&"
import script from "./kamikind.vue?vue&type=script&lang=js&"
export * from "./kamikind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports